import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Modal, Avatar, Space, Input, Button, Spin } from 'antd'

import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'
import classes from './styles/Member.module.css'

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const quarterNames = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4']

// Base heptagon points in percentages (0–100 range)
function generatePolygonTag(data, type, svgSize = 200) {
  const points = [
    { x: 50, y: 0 },
    { x: 90, y: 20 },
    { x: 100, y: 60 },
    { x: 75, y: 100 },
    { x: 25, y: 100 },
    { x: 0, y: 60 },
    { x: 10, y: 20 },
  ]

  // Adjust points based on data
  const adjustedPoints = points.map((point, index) => {
    let value = 0
    if (type === 'completedOnly') {
      value = parseFloat(data[index].complete)
    } else {
      value = parseFloat(data[index].incomplete)
    }

    const percentage = value / 100
    const adjustedX = 50 + (point.x - 50) * percentage
    const adjustedY = 50 + (point.y - 50) * percentage

    // scale to svgSize
    return {
      x: (adjustedX / 100) * svgSize,
      y: (adjustedY / 100) * svgSize,
    }
  })

  // Build points string for polygon
  const pointsString = adjustedPoints.map((p) => `${p.x},${p.y}`).join(' ')

  return <polygon points={pointsString} stroke="white" strokeWidth="1" fill={type === 'completedOnly' ? 'green' : '#efd992'} />
}

// Function to calculate current month, quarter, and year
const getCurrentDateInfo = () => {
  const currentDate = new Date()
  const month = currentDate.getMonth() + 1 // JavaScript months are 0-indexed
  const quarter = Math.ceil(month / 3)

  return {
    year: currentDate.getFullYear(),
    month,
    quarter,
  }
}

const statisticDataTemp = [
  {
    complete: '1%',
    incomplete: '1%',
    name: 'Personal Development',
    logo: {
      top: -39,
      left: 77,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/personal%20dev.png`,
    },
  },
  {
    complete: '1%',
    incomplete: '1%',
    name: 'Professional Development',
    logo: {
      top: 12,
      left: 172,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/professional%20dev.png`,
    },
  },
  {
    complete: '1%',
    incomplete: '1%',
    name: 'People Development',
    logo: {
      top: 97,
      left: 193,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/people%20dev.png`,
    },
  },
  {
    complete: '1%',
    incomplete: '1%',
    name: 'Play Experiential',
    logo: {
      top: 192,
      left: 135,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/play%20experiential.png`,
    },
  },
  {
    complete: '1%',
    incomplete: '1%',
    name: 'Health & Fitness',
    logo: {
      top: 190,
      left: 19,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/health%20fitness.png`,
    },
  },

  {
    complete: '1%',
    incomplete: '1%',
    name: 'Financial Health',
    logo: {
      top: 97,
      left: -38,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/financial%20health.png`,
    },
  },
  {
    complete: '1%',
    incomplete: '1%',
    name: 'Mental Emotional Spiritual',
    logo: {
      top: 12,
      left: -17,
      uri: `https://storage.googleapis.com/growdie/contents/manual-uploads/mental%20emotional%20spiritual.png`,
    },
  },
]

const pageOne = [
  { id: '1', label: 'Instagram', value: 23 },
  { id: '2', label: 'Tik-Tok', value: 54 },
  { id: '3', label: 'LinkedIn', value: 76 },
  { id: '4', label: 'Club Member', value: 67 },
  { id: '5', label: 'Friend', value: 77 },
  { id: '6', label: 'Google Search', value: 89 },
  { id: '7', label: 'Other', value: 95 },
]

const pageTwo = [
  { id: '1', label: 'Personal Development', value: 101 },
  { id: '2', label: 'Professional Development', value: 102 },
  { id: '3', label: 'People Development', value: 104 },
  { id: '4', label: 'Play/Experiential', value: 107 },
  { id: '5', label: 'Health & Fitness', value: 108 },
  { id: '6', label: 'Financial Health', value: 109 },
  { id: '7', label: 'Mental/Emotional/Spiritual Health', value: 103 },
  { id: '8', label: 'None of the above', value: 112 },
]

const pageThree = [
  { id: '1', label: 'I have success executing priorities', value: 201 },
  { id: '2', label: 'I have success building healthy habits', value: 202 },
  {
    id: '3',
    label: 'I can set, plan and lead projects and challenges from start to finish',
    value: 204,
  },
  {
    id: '4',
    label: 'I can set, plan and lead goals from start to finish',
    value: 207,
  },
]

const pageFour = [
  {
    id: '1',
    label: 'Little to no success leading myself and others',
    value: 301,
  },
  {
    id: '2',
    label: 'Noticeable success leading myself and others',
    value: 302,
  },
  { id: '3', label: 'Sustained success leading myself and others', value: 304 },
  { id: '4', label: 'Sustained success leading leaders', value: 307 },
  { id: '5', label: 'Sustained success leading change', value: 308 },
]

function Member() {
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState({})
  const [userClass, setUserClass] = useState(``)
  const [email, setEmail] = useState('')
  const navigate = useNavigate()
  const [statisticData, setStatisticData] = useState(statisticDataTemp)
  const [selectedPeriod, setSelectedPeriod] = useState('month')
  const [dateInfo, setDateInfo] = useState({ year: null, month: null, quarter: null }) // Used at: Monthly

  const handleButtonClick = (value) => {
    setSelectedPeriod(value)
    getUserRadarChart(value) // value e.g. month, quarterly or yearly
  }

  const handleBackNextClick = (type) => {
    // Below prev & next handled for month
    if (selectedPeriod == 'month' && type == 'prev') {
      if (dateInfo.month <= 1) {
        alert('You cant go back less than first month of each year.')
        return
      }
      setDateInfo({ year: dateInfo.year, month: dateInfo.month - 1, quarter: dateInfo.quarter })
      getUserRadarChart('monthNumber', dateInfo.month - 1)
    }
    if (selectedPeriod == 'month' && type == 'next') {
      const max = 12 // Adjust this value as needed
      if (dateInfo.month >= max) {
        alert(`You can not go more than last month of each year.`)
        return
      }
      setDateInfo({ year: dateInfo.year, month: dateInfo.month + 1, quarter: dateInfo.quarter })
      getUserRadarChart('monthNumber', dateInfo.month + 1)
    }

    // Below prev & next handled for quarterly
    if (selectedPeriod == 'quarterly' && type == 'prev') {
      if (dateInfo.quarter <= 1) {
        alert('You cant go back less than first quarter of each year.')
        return
      }
      setDateInfo({ year: dateInfo.year, month: dateInfo.month, quarter: dateInfo.quarter - 1 })
      getUserRadarChart('quarterNumber', dateInfo.quarter - 1)
    }
    if (selectedPeriod == 'quarterly' && type == 'next') {
      if (dateInfo.quarter <= 1) {
        alert(`You can not go more than last quarter of each year.`)
        return
      }
      setDateInfo({ year: dateInfo.year, month: dateInfo.month, quarter: dateInfo.quarter + 1 })
      getUserRadarChart('quarterNumber', dateInfo.quarter + 1)
    }

    // Below prev & next handled for yearly
    if (selectedPeriod == 'year' && type == 'prev') {
      setDateInfo({ year: dateInfo.year - 1, month: dateInfo.month, quarter: dateInfo.quarter })
      getUserRadarChart('yearNumber', dateInfo.year - 1)
    }
    if (selectedPeriod == 'year' && type == 'next') {
      setDateInfo({ year: dateInfo.year + 1, month: dateInfo.month, quarter: dateInfo.quarter })
      getUserRadarChart('yearNumber', dateInfo.year + 1)
    }
  }

  let { id } = useParams()
  const getAUser = async (values) => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/getAUser?id=${id}`)
      // console.log(response.data)
      setUser(response.data.user)
      if (response.data.user.class) setUserClass(response.data.user.class)
      if (response.data.user.email) setEmail(response.data.user.email)

      setLoading(false)
    } catch (error) {
      console.error('Request Error:', error)
      // You can handle the error here
      setLoading(false)
    }
  }

  const getUserRadarChart = async (range, value) => {
    try {
      setLoading(true)

      const rangeValue = range || selectedPeriod
      const valueData = value

      let qry = `/api/v1/focus/myEvents?range=${rangeValue}&userId=${id}&sendEvents=false`

      if (rangeValue == 'monthNumber') {
        if (valueData) {
          qry = qry.concat(`&month=${valueData}&year=${dateInfo.year}`)
        }
      } else if (rangeValue == 'quarterNumber') {
        if (valueData) {
          qry = qry.concat(`&quarter=${valueData}&year=${dateInfo.year}`)
        }
      } else if (rangeValue == 'yearNumber') {
        if (valueData) {
          qry = qry.concat(`&year=${valueData}`)
        }
      }

      // console.log(rangeValue == 'monthNumber')
      // console.log(valueData)
      // console.log(qry)

      const response = await axiosInstance.get(qry)
      let statistic = response?.data?.statistic

      // console.log(statistic)

      const percentMap = {}
      for (const key in statistic) {
        if (statistic.hasOwnProperty(key)) {
          percentMap[key] = {
            complete: statistic[key].percentComplete,
            incomplete: statistic[key].percentIncomplete == '99%' ? '1%' : statistic[key].percentIncomplete, // '99%' is not useful at heptagon, but server still sending this, because its needed at 'daily', 'weekly' bar charts
          }
        }
      }

      const updatedStatisticDataTemp = statisticDataTemp.map((item) => {
        const stat = percentMap[item.name] || {}
        return {
          complete: stat.complete ?? item.complete,
          incomplete: stat.incomplete ?? null, // or keep previous value if exists
          name: item.name,
          logo: item.logo,
        }
      })

      console.log(updatedStatisticDataTemp)

      setStatisticData(updatedStatisticDataTemp)

      setLoading(false)
    } catch (error) {
      console.error('Request Error:', error)
      // You can handle the error here
      setLoading(false)
    }
  }

  const updateAUser = async () => {
    try {
      setLoading(true)

      const body = {
        ...(userClass ? { class: userClass } : {}),
        ...(email ? { email: email } : {}),
      }

      const response = await axiosInstance.post(`/api/v1/admin/updateAUser?id=${id}`, body)
      // console.log(response.data)

      Modal.info({
        title: 'Success',
        content: (
          <div>
            <p>Your information has been udpated!</p>
          </div>
        ),
        onOk() {},
      })

      setLoading(false)
    } catch (error) {
      console.error('Request Error:', error)
      // You can handle the error here
      setLoading(false)
    }
  }

  const questionnaireItems = user?.questionnaireOne?.map((item, index) => {
    const { a: answer, q: question } = item // Destructuring for clarity
    const answerArray = []
    // console.log(answer)

    if (!answer || !question) {
      // Handle empty objects gracefully
      return null // Omit empty items from rendering
    }

    if (question == 'source') {
      answer?.forEach((answerItem) => {
        pageOne.forEach((pageItem) => {
          if (answerItem == pageItem.value) {
            answerArray.push(pageItem)
          }
        })
      })
    }

    if (question == 'investedOwn') {
      // console.log(answer)
      answer?.forEach((answerItem) => {
        pageTwo.forEach((pageItem) => {
          if (answerItem == pageItem.value) {
            answerArray.push(pageItem)
          }
        })
      })
    }

    if (question == 'investedOthers') {
      console.log(answer)
      answer?.forEach((answerItem) => {
        pageThree.forEach((pageItem) => {
          if (answerItem == pageItem.value) {
            answerArray.push(pageItem)
          }
        })
      })
    }

    if (question == 'interestedArea') {
      console.log(answer)
      answer?.forEach((answerItem) => {
        pageFour.forEach((pageItem) => {
          if (answerItem == pageItem.value) {
            answerArray.push(pageItem)
          }
        })
      })
    }

    let formattedQuestion
    switch (question) {
      case 'source':
        formattedQuestion = 'User found this platform at the source of:'
        break
      case 'investedOwn':
        formattedQuestion = 'Years invested in their own health and fitness:'
        break
      case 'investedOthers':
        formattedQuestion = "Years invested in others' health and fitness:"
        break
      case 'interestedArea':
        formattedQuestion = 'Area of interest in health and fitness:'
        break
      default:
        formattedQuestion = question // Use original question for unknown keys
    }

    return (
      <div key={index} className={classes.questionnaireItem}>
        <span className={classes.question}>{formattedQuestion}</span>
        {answerArray.map((el) => {
          return <span className={classes.answer}>{el.label}</span>
        })}
      </div>
    )
  })

  useEffect(() => {
    getAUser()
    getUserRadarChart()

    // Intitial getUserRadarChart() call don't require this below portion, but after first load for doing prev and next this below portion is required
    const { year: yearReturned, month: monthReturned, quarter } = getCurrentDateInfo()
    setDateInfo({ year: yearReturned, month: monthReturned, quarter })
  }, [])

  return (
    <Layout>
      <ArrowLeftOutlined
        style={{
          color: '#1677ff',
          fontSize: '1.5rem',
          marginBottom: 20,
          cursor: 'pointer',
        }}
        onClick={() => navigate('/members')}
      />
      <div>Member info</div>
      <br />
      <Avatar
        size={{
          xs: 24,
          sm: 32,
          md: 40,
          lg: 64,
          xl: 80,
          xxl: 100,
        }}
        src={
          (user.profilePicture && user.profilePicture[0].bucketResponse.mediaLink) ||
          `https://storage.googleapis.com/growdie/contents/manual-uploads/placeholder-people-compress-1.png`
        }
      />
      {user.profilePicture?.[0].bucketResponse?.size && <p>Image size: {(user.profilePicture?.[0].bucketResponse?.size / (1024 * 1024)).toFixed(3)} MB</p>}

      {loading && <Spin size="large" />}

      <div className={classes.containerOne}>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginBottom: 10 }}>
          <Space>
            <Button onClick={() => handleButtonClick('month')} className={selectedPeriod === 'month' ? classes.selectedButtonStyle : classes.baseButtonStyle}>
              Monthly
            </Button>
            <Button onClick={() => handleButtonClick('quarterly')} className={selectedPeriod === 'quarterly' ? classes.selectedButtonStyle : classes.baseButtonStyle}>
              Quarterly
            </Button>
            <Button onClick={() => handleButtonClick('year')} className={selectedPeriod === 'year' ? classes.selectedButtonStyle : classes.baseButtonStyle}>
              Yearly
            </Button>
          </Space>
        </div>
        <div style={{ position: 'relative', width: 200, height: 200, marginTop: 60, marginBottom: 60, marginLeft: 40 }}>
          <svg height="200" width="200" viewBox="0 0 210 210" style={{ marginTop: -8, marginLeft: -6 }}>
            <polygon points="100,0 180,40 200,120 150,200 50,200 0,120 20,40" stroke="black" strokeWidth="1" fill="white" />
            <polygon points="100,0 180,40 200,120 150,200 50,200 0,120 20,40" stroke="black" stroke-width="1" fill="white" />
            <polygon points="100,25 160,55 175,115 140,175 60,175 25,115 40,55" stroke="white" stroke-width="1" fill="#F5F5F5" />
            <polygon points="100,50 140,70 150,110 125,150 75,150 50,110 60,70" stroke="white" stroke-width="1" fill="white" />
            <polygon points="100,75 120,85 125,105 115,125 85,125 75,105 80,85" stroke="white" stroke-width="0" fill="#F5F5F5" />

            {/* Inner layers for testings */}
            {/* <polygon points="100,50 140,70 150,110 125,150 75,150 50,110 60,70" stroke="white" strokeWidth="1" fill="grey" />
            <polygon points="100,75 120,85 125,105 115,125 85,125 75,105 80,85" stroke="white" strokeWidth="0" fill="red" /> */}
            {generatePolygonTag(statisticData, 'all')}
            {generatePolygonTag(statisticData, 'completedOnly')}
          </svg>

          {/* Icons goes here with abosolute positioning */}

          {statisticDataTemp.map((el, idx) => (
            <div
              key={idx}
              style={{
                position: 'absolute',
                top: el.logo.top,
                left: el.logo.left,
              }}
            >
              <img
                src={el.logo.uri}
                alt={el.name}
                style={{
                  width: '24px',
                  height: '24px',
                  objectFit: 'contain',
                }}
              />
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginBottom: 10 }}>
          <Space>
            <Button onClick={() => handleBackNextClick('prev')} className={classes.baseButtonStyle} disabled={loading}>
              Back
            </Button>
            {selectedPeriod == 'month' && <p> {months[dateInfo.month - 1]}</p>}
            {selectedPeriod == 'quarterly' && <p>{quarterNames[dateInfo.quarter - 1]}</p>}
            {selectedPeriod == 'year' && <p>{dateInfo.year}</p>}
            <Button onClick={() => handleBackNextClick('next')} className={classes.baseButtonStyle} disabled={loading}>
              Next
            </Button>
          </Space>
        </div>

        <p className={classes.label}>Name</p>
        <p>{`${user.firstName} ${user.lastName}`}</p>

        <p className={classes.label}>Email</p>
        <p> {`${user.email}`}</p>
        {/* <Input
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
        /> */}

        <p className={classes.label}>Time zone GMT (Caution! It's live update while you type! ⚠️)</p>
        <p>Current one: {user.timeZoneGMT}</p>
        <Input
          style={{ width: 200 }}
          placeholder="Type like: +6 or -5"
          onChange={async (e) => {
            await axiosInstance.post(`/api/v1/admin/updateAUser?id=${id}`, { timeZoneGMT: e.target.value })
          }}
        />

        <p className={classes.label}>Email verified</p>
        <p>Auto</p>

        <p className={classes.label}>Signup type</p>
        <p>{user.signupType}</p>

        <p className={classes.label}>Joined At</p>
        <p>{user.joinedAt ? <>{user.joinedAt.map((el, idx) => `|| ${el.name} ||`)}</> : 'Not found'}</p>

        <p className={classes.label}>User type</p>
        <p>{user.type}</p>

        <p className={classes.label}>Created at</p>
        <p>{new Date(user.createdAt).toLocaleString()}</p>

        <p className={classes.label}>Address</p>
        <p>{user.address}</p>

        <p className={classes.label}>State</p>
        <p>{user.questionnaireTwo?.state}</p>

        <p className={classes.label}>Gender</p>
        <p>{user.gender}</p>

        <p className={classes.label}>Age</p>
        <p>{user.age}</p>

        <p className={classes.label}>Biography</p>
        <p>{user.biography}</p>

        <p className={classes.label}>Phone</p>
        <p>{user.phone}</p>

        <p className={classes.label}>Date of birth</p>
        <p>{user.dateOfBirth && new Date(user.dateOfBirth).toLocaleDateString()}</p>

        <p className={classes.label}>Questionnaire set one</p>
        {questionnaireItems}

        <p className={classes.label}>User class</p>
        <Space.Compact
          style={{
            width: '50%',
          }}
        >
          <Input
            placeholder="Write class name and submit"
            value={userClass}
            onChange={(e) => {
              setUserClass(e.target.value)
            }}
          />
        </Space.Compact>
        <br />
        <br />
        <Button type="primary" onClick={updateAUser}>
          Update Info
        </Button>
      </div>
    </Layout>
  )
}

export default Member
